import { pushEvent } from 'src/client/data-layer';
import { LayoutMode } from 'src/components/layout-buttons/types';

export const trackSearchNoResultViewed = (value?: string) => {
  pushEvent('searchNoResultViewed', { value });
};

export const trackSearchCleared = () => {
  pushEvent('searchCleared');
};

export const trackSearchResultCategoriesListed = () => {
  pushEvent('searchResultCategoriesListed');
};

export const trackSearchResultStoresListed = () => {
  pushEvent('searchResultStoresListed');
};

export const trackSearchResultBrandsListed = () => {
  pushEvent('searchResultBrandsListed');
};

export const trackSearchResultProductsListed = (layout: LayoutMode) => {
  pushEvent('searchResultProductsListed', { layout });
};

export const trackSearchResultProductClicked = (
  id: string | number,
  name?: string
) => {
  pushEvent('searchResultProductClicked', {
    id,
    name,
  });
};

export const trackSearchResultCategoryClicked = (id: string, title: string) => {
  pushEvent('searchResultCategoryClicked', {
    id,
    title,
  });
};

export const trackSearchResultBrandClicked = (id: string, title: string) => {
  pushEvent('searchResultBrandClicked', {
    id: Number(id),
    title,
  });
};

export const trackSearchResultStoreClicked = (
  id: number | string,
  title: string
) => {
  pushEvent('searchResultStoreClicked', {
    id,
    title,
  });
};

export const trackSearchDidYouMeanClicked = (
  query: string,
  suggestedQuery: string
) => {
  pushEvent('searchDidYouMeanClicked', {
    query,
    suggestedQuery,
  });
};

export const trackSearchResultSwitchLayout = (
  previousLayout: LayoutMode,
  layout: LayoutMode
) => {
  pushEvent('searchResultSwitchLayout', {
    previousLayout,
    layout,
  });
};
